<template>
	<div class="d-flex align-items-center">
		<div
			class=""
			:class="isLaptop ? 'mr-3 ' : ''"
			v-if="$route.name == 'CandidateDashboard' && !project.parser"
		>
			<img
				class="drag-handleProj"
				src="../../../assets/newdesign/dashboard/6dots.svg"
				alt=""
			/>
		</div>
		<div
			class="mt-2 p-2 position-relative mob-align-items-start"
			:class="{
				'candash-red-details-box': project.parser,
				'candash-blue-details-nowid': !project.parser,
				'resume-builder-card-width':
					!project.parser && $route.name === 'CandidateDashboard',
				'w-100': project.parser || $route.name !== 'CandidateDashboard',
			}"
		>
			<div
				@click="
					openInsideProProject[project.uniqueID] =
						!openInsideProProject[project.uniqueID]
				"
				class="d-flex"
			>
				<img
					class="mr-3 lapicon"
					src="../../../assets/newdesign/dashboard/projDp.svg"
					alt=""
				/>
				<img
					class="mr-2 mobicon"
					src="../../../assets/newbuilder/mobproject.svg"
					alt=""
				/>
				<div class="d-flex justify-content-between mob-w-88 w-100">
					<div class="mob-w-95 w80">
						<div
							class="bold-bluetxt mr-5"
							:class="project.title ? '' : 'not-mention-txt'"
						>
							{{ project.title ? project.title : "Not Mentioned" }}
						</div>
						<div
							:class="
								isLaptop
									? ''
									: 'd-flex align-items-center justify-content-between mt-1'
							"
						>
							<div
								:class="
									isLaptop
										? 'mt-2'
										: project.startDate || project.endDate
										? ''
										: 'not-mention-txt'
								"
								class="js-description-font w-65 text-truncate"
							>
								{{
									project.startDate == null || project.startDate == ""
										? "Not Mentioned"
										: formatMonthName(project.startDate)
								}}&nbsp; - &nbsp;
								<span v-if="!project.currentProject">{{
									project.endDate == null || project.endDate == ""
										? "Not Mentioned"
										: formatMonthName(project.endDate)
								}}</span>
								<span v-else class="js-description-font"> Current</span>
							</div>
							<div
								v-if="!openInsideProProject[project.uniqueID]"
								class="mobile-view-more-txt text-blue hideinlaptop"
								@click.stop="
									openInsideProProject[project.uniqueID] =
										!openInsideProProject[project.uniqueID]
								"
							>
								View more
								<img
									class="ml-1 mobrotate-180"
									src="@/assets/job-search-icons/mob-uparrow.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
					<div class="pt-2 pr-2 laptop-ed-icons">
						<img
							@click.stop="openEdit()"
							class="mr-2 pointer blueShadow"
							src="../../../assets/newdesign/dashboard/blueEdit1.svg"
							alt=""
						/>
						<img
							@click.stop="deleteData()"
							src="../../../assets/newdesign/dashboard/blueDelete1.svg"
							alt=""
							class="mr-2 pointer blueShadow"
						/>

						<img
							v-if="project.parser"
							src="../../../assets/newdesign/dashboard/disableadd.svg"
							alt=""
						/>
						<img
							v-else-if="!openInsideProProject[project.uniqueID]"
							src="../../../assets/newdesign/dashboard/whiteBlueDown.svg"
							alt=""
							class="pointer blueShadow"
						/>
						<img
							v-else
							src="../../../assets/newdesign/dashboard/whiteBlueUp.svg"
							alt=""
							class="pointer blueShadow"
						/>
					</div>
					<div
						class="mobile-ed-icons"
						@click.stop="$emit('select-card', project.uniqueID)"
					>
						<img src="@/assets/newbuilder/threedots.svg" alt="" />
						<div
							class="ed-box"
							v-if="selectedCard == project.uniqueID"
							:ref="'cardopen' + project.uniqueID"
						>
							<div
								class="ed-box-option d-flex align-items-center pl-2 pointer"
								@click.stop="openEdit()"
							>
								<img
									src="@/assets/newbuilder/ddedit.svg"
									class="mr-2"
									alt=""
								/>Edit
							</div>
							<div
								class="ed-box-option d-flex align-items-center pl-2 pointer"
								@click.stop="deleteData()"
							>
								<img
									src="@/assets/newbuilder/delete.svg"
									class="mr-2"
									alt=""
								/>Delete
							</div>
						</div>
					</div>
				</div>
			</div>
			<b-collapse
				v-model="openInsideProProject[project.uniqueID]"
				class="pt-1 pl-2 pr-2 pb-2"
			>
				<div class="candash-blackTxt ml-60 mobml-0">
					{{ project.summary }}
				</div>
				<b-row class="mt-3">
					<b-col :cols="isLaptop ? '6' : '12'">
						<div class="mobflex mobmb-2">
							<div class="candash-displaytxt-grey mobw-15">Project Role</div>
							<div
								class="candash-bold-grey mt-1 mobml-3 mobmt-0"
								:class="project.role ? '' : 'not-mention-txt'"
							>
								{{ project.role ? project.role : "Not Mentioned" }}
							</div>
						</div>
					</b-col>
					<b-col :cols="isLaptop ? '3' : project.client ? '6' : '12'">
						<div class="mobflex">
							<div class="candash-displaytxt-grey">Domain</div>
							<div
								class="candash-bold-grey mt-1 text-break mobml-3 mobmt-0"
								:class="
									project.domain
										? project.domain
										: (project.parser ? 'Not Mentioned' : '') ==
												'Not Mentioned' && 'not-mention-txt'
								"
							>
								{{
									project.domain
										? project.domain
										: project.parser
										? "Not Mentioned"
										: ""
								}}
							</div>
						</div>
					</b-col>
					<b-col :cols="isLaptop ? '3' : '6'" class="mobpx-0">
						<div class="mobflex" v-if="project.client">
							<div class="candash-displaytxt-grey">Client</div>
							<div
								class="candash-bold-grey mt-1 text-break mobml-3 mobmt-0"
								:class="
									project.client
										? project.client
										: (project.parser ? 'Not Mentioned' : '') ==
												'Not Mentioned' && 'not-mention-txt'
								"
							>
								{{
									project.client
										? project.client
										: project.parser
										? "Not Mentioned"
										: ""
								}}
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col v-if="project.skillsUsed && project.skillsUsed.length > 0">
						<!-- <div class="candash-displaytxt-grey">Skills Used</div> -->
						<div class="d-flex flex-wrap">
							<div class="min-w40 mobw-100 mobmb-2 mr-4">
								<div class="candash-displaytxt-grey">Skills Used</div>
								<div class="d-flex flex-wrap min-w40 max-w100">
									<div
										v-for="(skill, index1) in project.skillsUsed"
										:key="index1 + 'skill'"
										class="candash-skillTag-2 mt-1 mr-2 mb-2"
									>
										{{ skill }}
									</div>
								</div>
							</div>
							<div
								v-if="
									project.association != null && project.association_obj != null
								"
								class="min-w40 mobw-100"
							>
								<div class="candash-displaytxt-grey">Associated With</div>
								<div class="candash-bold-grey mt-1">
									{{
										"companyName" in project.association_obj
											? project.association_obj.companyName
											: project.association_obj.institute
									}}
								</div>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row class="mt-3" v-if="project.description">
					<b-col>
						<div class="candash-displaytxt-grey">Description</div>
						<div v-if="project.description" class="candash-blackTxt mt-1">
							{{ truncatedProjectDescription(project.description) }}
							<span v-if="project.description.length > 256">...</span>
							<span
								v-if="project.description.length > 256 && !showFullContent"
								class="pro-theme pointer"
								@click="showMore()"
								>show more</span
							>
							<span
								class="pro-theme pointer"
								v-if="showFullContent"
								@click="showLess()"
								>show less</span
							>
						</div>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<div class="candash-displaytxt-grey">Responsibilities</div>
						<div
							class="candash-blackTxt text-break mt-1"
							v-if="
								project.responsibility.filter((res) => res.trim() !== '')
									.length > 0
							"
						>
							<ul
								class="candash-dotted-list"
								v-for="(ress, ind) in project.responsibility
									.filter((res) => res.trim() !== '')
									.slice(
										0,
										showMoreResponsibility[project.uniqueID]
											? project.responsibility.filter(
													(res) => res.trim() !== ''
											  ).length
											: 1
									)"
								:key="ind + 'ress'"
							>
								<li>
									{{ ress }}
								</li>
							</ul>
						</div>
						<span
							v-if="
								project.responsibility.filter((res) => res.trim() !== '')
									.length > 1 && !showMoreResponsibility[project.uniqueID]
							"
							class="pro-theme pointer"
							@click="toggleMoreResponsibility(project.uniqueID)"
							>show more</span
						>
						<span
							class="pro-theme pointer"
							v-if="showMoreResponsibility[project.uniqueID]"
							@click="toggleMoreResponsibility(project.uniqueID)"
							>show less</span
						>
					</b-col>
				</b-row>
				<div
					class="mobile-view-more-txt text-blue hideinlaptop w-100 d-flex justify-content-end"
					@click.stop="
						openInsideProProject[project.uniqueID] =
							!openInsideProProject[project.uniqueID]
					"
				>
					View less
					<img
						class="ml-1"
						src="@/assets/job-search-icons/mob-uparrow.svg"
						alt=""
					/>
				</div>
			</b-collapse>
		</div>
	</div>
</template>

<script>
import { formatMonthNameShort } from "../../../controllers/dashboard/helpers.js";
export default {
	name: "ProjectCard",
	props: {
		selectedCard: String,
		project: Object,
		isLaptop: Boolean,
		formConfiguration: Object,
		form: Object,
	},
	data() {
		return {
			showFullContent: false,
			openInsideProProject: {},
			showMoreResponsibility: [],
		};
	},
	created() {
		if (this.project.parser && this.isLaptop) {
			this.openInsideProProject[this.project.uniqueID] =
				!this.openInsideProProject[this.project.uniqueID]; // Use project.parser to set the initial collapse state
		}
	},
	mounted() {
		document.addEventListener("click", this.clickon);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.clickon);
	},
	methods: {
		formatMonthName(inputDate) {
			return formatMonthNameShort(inputDate);
		},
		clickon() {
			let id = "cardopen" + this.project.uniqueID;
			if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
				this.$emit("select-card", "");
			}
		},
		truncatedProjectDescription(cont) {
			return this.showFullContent ? cont : cont.slice(0, 256);
		},
		toggleMoreResponsibility(uniqueID) {
			this.$set(
				this.showMoreResponsibility,
				uniqueID,
				!this.showMoreResponsibility[uniqueID]
			);
		},
		deleteData() {
			this.$emit("delete-data", { content: this.project, form: this.form });
		},
		openEdit() {
			this.$emit("edit-form", {
				form: this.form,
				content: this.project,
				id: this.project.uniqueID,
			});
		},
	},
};
</script>

<style></style>
